<ng-container *ngIf="dialog$ | async as dialog">
    <div class="paybee-modal-header">
        <div class="modal-title">{{ title }}</div>
      </div>
      <div class="modal-body">
        <div class="text-center" [innerHTML]="text"></div>
      </div>
      <div class="modal-footer paybee-modal-footer">
        <div class="row">
          <div class="col-4 offset-4">
            <button type="button" class="btn btn--paybee btn--cancel btn--md text-center w-100" (click)="onClose(false)" >No</button>
          </div>
          <div class="col-4">
            <button type="button" class="btn btn--paybee btn--success btn--md text-center w-100" (click)="onClose(true)">Yes</button>
          </div>
        </div>
      </div>  
</ng-container>
